import throttle from 'lib/function/throttle'
import { useEffect, useState } from 'react'

function useOnScreen(
  startElement: HTMLElement | null,
  endElement: HTMLElement | null,
  rootMargin: number = 0,
  rootMarginBottom: number = 0,
  height: number = 0,
): boolean {
  const [isIntersecting, setIntersecting] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (startElement && endElement) {
        if (startElement.getBoundingClientRect().top + rootMargin <= 0 && (endElement.getBoundingClientRect()?.top - rootMarginBottom >= 0 || (height && startElement.getBoundingClientRect().bottom + height >= 0))) {
          setIntersecting(true)
        } else {
          setIntersecting(false)
        }
      }
    }

    window.addEventListener('scroll', throttle(handleScroll, 200, { leading: true, trailing: true }))

    return () => {
      window.removeEventListener('scroll', () => throttle(handleScroll, 200))
    }
  }, [startElement, endElement, rootMargin, height, rootMarginBottom])

  return isIntersecting
}

export default useOnScreen
